import React from "react";

const ModalTermos = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-11/12 max-w-3xl max-h-[90vh] overflow-y-auto relative">
        {/* Cabeçalho */}
        <div className="bg-green-600 px-6 py-4 text-center">
          <h1 className="text-3xl sm:text-2xl font-bold text-white">
            Termos de Uso - Dominus
          </h1>
          <p className="text-green-100 mt-1">
            Última atualização: 30 de abril de 2025
          </p>
        </div>

        {/* Conteúdo do Modal */}
        <div className="p-6 space-y-10">
          <section className="mb-2">
            <div className="flex items-center mb-6 pb-2 border-b border-gray-200">
              <span className="text-2xl mr-2">📜</span>
              <h2 className="text-xl font-bold text-gray-800">
                2. TERMOS E CONDIÇÕES DE USO
              </h2>
            </div>

            <div className="space-y-8">
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  1.1. Uso do site
                </h3>
                <p className="text-gray-700 mb-2">
                  O site www.dominus.com.br destina-se à venda de produtos
                  eletrônicos. O acesso é gratuito, mas algumas funcionalidades
                  exigem cadastro.
                </p>
                <p className="text-gray-700">
                  O usuário se compromete a fornecer informações verídicas e
                  manter seus dados atualizados.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  1.2. Compras e pagamentos
                </h3>
                <ul className="pl-5 list-disc text-gray-700 space-y-1">
                  <li>Os preços estão sujeitos a alterações sem aviso prévio;</li>
                  <li>Pedidos dependem de confirmação de pagamento e disponibilidade de estoque;</li>
                  <li>A Dominus pode recusar pedidos em casos de erro, suspeita de fraude ou inconsistência de dados.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  1.3. Responsabilidades do usuário
                </h3>
                <p className="text-gray-700 mb-2">É proibido:</p>
                <ul className="pl-5 list-disc text-gray-700 space-y-1">
                  <li>Utilizar o site para fins ilícitos;</li>
                  <li>Transmitir conteúdo malicioso, ofensivo ou fraudulento;</li>
                  <li>Copiar, alterar ou distribuir conteúdos do site sem autorização.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  1.4. Propriedade intelectual
                </h3>
                <p className="text-gray-700">
                  Todo o conteúdo do site é protegido por direitos autorais. O
                  uso indevido sujeita o infrator às penalidades previstas em
                  lei.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  1.5. Links de terceiros
                </h3>
                <p className="text-gray-700">
                  Podem haver links para sites de terceiros. A Dominus não se
                  responsabiliza por seus conteúdos ou práticas de privacidade.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  1.6. Modificações dos termos
                </h3>
                <p className="text-gray-700">
                  Estes termos podem ser atualizados a qualquer momento. A
                  versão vigente estará sempre disponível no site.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  1.7. Foro
                </h3>
                <p className="text-gray-700">
                  Este documento é regido pelas leis da República Federativa
                  do Brasil. Fica eleito o foro da comarca de [cidade/UF] para
                  resolução de conflitos.
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* Rodapé - Botão de Fechar */}
        <div className="px-6 pb-6">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-600 transition-colors"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalTermos;
